/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_AccessibilityInputs */

const de_commons_footer_accessibility = /** @type {(inputs: Commons_Footer_AccessibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barrierefreiheit`)
};

/** @type {(inputs: Commons_Footer_AccessibilityInputs) => LocalizedString} */
const en_commons_footer_accessibility = de_commons_footer_accessibility;

/**

* @param {Commons_Footer_AccessibilityInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_accessibility = /** @type {((inputs?: Commons_Footer_AccessibilityInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_AccessibilityInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_accessibility(inputs)
	return en_commons_footer_accessibility(inputs)
});